import React, { useState } from 'react';
import './Login.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function Login(props) {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [error, setError] = useState(false);
    const [showNumberInput, setShowNumberInput] = useState(true);
    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const navigate = useNavigate();

    function handleSubmit() {
        if (phoneNumber.toString().length === 10) {
            postPhoneNumber();
            setShowNumberInput(false);
        } else {
            setError(true);
        }
    }

    function postPhoneNumber() {
        axios.post(`https://ad-prod.smytten.com/offline/session`, {
            phone_number: parseInt(phoneNumber)
        }).then((res) => {
            console.log(res.data, "posting-numbers")
            setError(false)
        }).catch((err) => {
            console.log(err, "error...");
            setError(true)
        })
    }

    function otpErrorHandler() {
        if (isNaN(otp) || otp.length === 0 || otp.length > 4) {
            setOtpError('Enter correct otp');
            return true;
        } else {
            setOtpError('');
            return false;
        }
    }

    function handleSubmitOtp() {

        if (!otpErrorHandler()) {
            setOtpError('');
            axios.put(`https://ad-prod.smytten.com/offline/session`, {
                phone_number: phoneNumber,
                otp: otp
            }).then((res) => {
                console.log(res.data, "updating-details...")
                props.setagentId(res.data?.agent_id);
                navigate(`/offline-frontend/leadlist/${res.data?.agent_id}`);
            }).catch((err) => {
                console.log(err, "error...otp");
            })
        }

    }


    function handleOnChangeNumber(e) {
        if (e.target.value.length <= 10) {
            setPhoneNumber(parseInt(e.target.value))
        }
    }

    function renderContent() {
        if (showNumberInput) {
            return (
                <div className='number-submit-container'>
                    <div className='input-group'>
                        <TextField id="outlined-basic"
                            label="Phone number"
                            variant="outlined"
                            size='small'
                            required
                            type='number'
                            value={phoneNumber}
                            onChange={(e) =>
                                handleOnChangeNumber(e)}
                        />
                        {error && phoneNumber.toString().length !== 10 && <span className='error-number'>*please enter correct phone number</span>}
                    </div>
                    <Button variant="contained"
                        onClick={() => handleSubmit()}
                        style={{ backgroundColor: '#20225D', fontWeight: 'bold' }}
                    >Submit</Button>

                </div>

            )
        } else {
            return (
                <div className='number-submit-container'>
                    <div className='input-group'>
                        <TextField id="outlined-basic"
                            label="ENTER OTP"
                            variant="outlined"
                            size='small'
                            required
                            type='number'
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                        />
                        {otpError && otp.toString().length !== 4 && <span className='error-number'>{otpError}</span>}

                    </div>
                    <Button variant="contained"
                        onClick={() => handleSubmitOtp()}
                        style={{ backgroundColor: '#20225D', fontWeight: 'bold' }}
                    >
                        Submit
                    </Button>

                </div>
            )
        }
    }


    return (
        <div className='main-container'>
            <div className='logo-container'>
                <h1 className='logo-text-login'>SMYTTEN</h1>
            </div>

            <div className='login-main-container'>
                <div className='form-container-login'>
                    <h2 className='offline-text'>OFFLINE SAMPLING</h2>
                    {renderContent()}
                </div>
            </div>
        </div>
    )
}

export default Login;